/* Hjälpfunktioner för LF-5 "Spara i projektet": förifylld titel,
   ursprungsfrågan, källmappning till kontraktets sources-form och
   förhandsvisnings-objekt för det sparade dokumentet. */
import { API_URL } from "../../api";
import { withTenantSlug } from "./chatData";

export const TITLE_MAX_LENGTH = 120;

/* Titeln får vara max 120 tecken inklusive avslutande ellips. */
export function truncateTitle(text, max = TITLE_MAX_LENGTH) {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max - 1).trimEnd()}…`;
}

/* Ursprungsfrågan = närmast föregående användarmeddelande i tråden. */
export function findQuestionFor(chatMessages, idx) {
  const list = Array.isArray(chatMessages) ? chatMessages : [];
  for (let i = idx - 1; i >= 0; i -= 1) {
    const m = list[i];
    if (m?.role === "user" && typeof m.content === "string" && m.content.trim()) {
      return m.content.trim();
    }
  }
  return "";
}

function pageSuffix(page) {
  const n = Number(page);
  return Number.isFinite(n) && n > 0 ? ` s. ${n}` : "";
}

/* Källor till kontraktets form [{document_id, page, label}], deduplicerat
   på dokument + sida. Dokumentkällor (RAG-träffar) först, sedan citations
   som pekar på ett dokument. */
export function collectSources(msg) {
  const out = [];
  const seen = new Set();
  const push = (documentId, page, name) => {
    if (!documentId) return;
    const pageNo = Number(page);
    const safePage = Number.isFinite(pageNo) && pageNo > 0 ? pageNo : null;
    const key = `${documentId}:${safePage ?? ""}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push({
      document_id: String(documentId),
      page: safePage,
      label: `${name || `Dokument ${documentId}`}${pageSuffix(safePage)}`,
    });
  };
  (Array.isArray(msg?.documentCitations) ? msg.documentCitations : []).forEach((c) => {
    push(c?.documentId, c?.page, c?.documentName);
  });
  (Array.isArray(msg?.citations) ? msg.citations : []).forEach((c) => {
    if (!c?.document_id) return;
    const name = c.document_name || c.filename
      || (c.relative_path ? c.relative_path.split("/").pop() : "") || c.path;
    push(c.document_id, c.page, name);
  });
  return out;
}

/* Projekt i sammanhanget: modulens projekt-id går före ett eventuellt
   projekt-id på själva meddelandet. */
export function resolveProjectId(projectId, msg) {
  const candidate = projectId ?? msg?.projectId ?? null;
  const n = Number(candidate);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function artifactDownloadUrl(projectId, documentId) {
  const docId = encodeURIComponent(String(documentId));
  return withTenantSlug(`${API_URL}/projects/${projectId}/documents/${docId}/download`);
}

/* DocumentPreviewModal-objekt för ett sparat svar. Namnet får .md så att
   förhandsvisningen väljer textläge (filePreview-vitlistan). */
export function previewDocForArtifact(artifact) {
  if (!artifact?.document_id || !artifact?.project_id) return null;
  const title = artifact.title || "KanAI-svar";
  return {
    id: artifact.document_id,
    name: /\.md$/i.test(title) ? title : `${title}.md`,
    download_url: artifactDownloadUrl(artifact.project_id, artifact.document_id),
  };
}

/* Stabil nyckel per meddelande så att "Sparat"-raden följer rätt svar. */
export function messageKey(msg, idx) {
  return msg?.timestamp ? `t-${msg.timestamp}` : `i-${idx}`;
}
